// extracted by mini-css-extract-plugin
export default {"container":"card_container__R+aI4","icon":"card_icon__bIlCf","title":"card_title__8whru","description":"card_description__JOgjN"};